// index.js
import allocations from './allocations.js';
import projectLedger from './project-ledger.js';
import projectTasks from './project-tasks.js';
import projectRoles from './project-roles.js';
import projectAssignments from './project-assignments.js';
import invoices from './invoices.js';
import invoiceLines from './invoice-lines.js';
import costs from './costs.js';
import expenseItems from './expense-items.js';
import memberSkillAssignments from './member-skill-assignments.js';

const csvRules = {
  allocations,
  projectLedger,
  projectTasks,
  projectRoles,
  projectAssignments,
  invoices,
  invoiceLines,
  costs,
  expenseItems,
  memberSkillAssignments,
};

const samplefiles = {
  allocations: 'allocations.csv',
  projectLedger: 'project-ledger.csv',
  projectTasks: 'project-tasks.csv',
  projectRoles: 'project-roles.csv',
  projectAssignments: 'project-assignments.csv',
  invoices: 'invoice-headers.csv',
  invoiceLines: 'invoice-lines.csv',
  costs: 'member-costs.csv',
  expenseItems: 'expense-items.csv',
  memberSkillAssignments: 'memberSkillAssignments.csv',
};

export default { csvRules, samplefiles };
